// extracted by mini-css-extract-plugin
export default {"container":"ApplicationBatch_container__XRJgg","description":"ApplicationBatch_description__ekVdJ","table":"ApplicationBatch_table__4PCWv"};